import {  get, publicPost,post, put, deleteRequest } from "../helpers/apihelpers";

export const CreateOnboardService=async(data)=>{
    try {
        const result = await publicPost(`api/user/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateOnboardService=async(data,id)=>{
    try {
        const result = await post(`api/user/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteOnboardService=async(id)=>{
    try {
        const result = await deleteRequest(`api/user/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetOnboardDetailService=async(id)=>{
    try {
        const result = await get(`api/user/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetOnboardListService=async(page)=>{
    try {
        const result = await get(`api/user/get/${page}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateRoleService = async (data) => {
    try {
        const result = await put(`api/user/assign-user-roles`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}